import { ProductInterface } from 'modules/product/interfaces/product.interface';

//  const SHOW_CATEGORY_ID = 'a19';

export function isShowSimilarOffers(product: ProductInterface): boolean {
    /** Disabled at 26.10.2025 due to issues in the CSS Center
    if (product.category.path[0].category.id === SHOW_CATEGORY_ID && product.offers.count > 0) {
        const dealerId = product.offers.items[0].dealer.id;

        return product.offers.items.every(item => item.dealer.id === dealerId);
    }
    */

    return false;
}
